import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

/**
 * Catch-all fallback guard: sends any unmatched URL to the registration start,
 * dropping every query param (programmatic navigate does not carry them over).
 */
@Injectable({
  providedIn: 'root'
})
export class RedirectToRegistrationGuard implements CanActivate {
  constructor(private readonly router: Router) {}

  canActivate(): boolean {
    this.router.navigate(['/registration']);
    return false;
  }
}
